/* ============================================
   Goldea - Cijfer animatie voor statistieken
   File: assets/stats-counter.js
   Voeg toe via theme.liquid voor </body>
   ============================================ */

(function() {
  function animateCounter(el, target, duration) {
    // Haal het getal op uit de tekst (bv "69%" → 69, "50%+" → 50)
    const suffix = el.textContent.replace(/[\d.]/g, '').trim(); // bv "%" of "%+"
    const start = 0;
    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Easing: snel omhoog, langzaam stoppen
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(start + (target - start) * eased);
      el.textContent = current + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = target + suffix;
      }
    }

    requestAnimationFrame(update);
  }

  function parseNumber(text) {
    // "69%" → 69, "50%+" → 50, "26%" → 26
    const match = text.match(/(\d+\.?\d*)/);
    return match ? parseFloat(match[1]) : null;
  }

  function initCounters() {
    // Selecteer alle feature-title elementen die een getal bevatten
    const titles = document.querySelectorAll('[class*="ai-parallax-feature-title-"]');

    titles.forEach(el => {
      const number = parseNumber(el.textContent);
      if (number === null) return;

      // Sla originele tekst op
      el.dataset.target = number;
      el.dataset.suffix = el.textContent.replace(/[\d.]/g, '').trim();
      el.dataset.animated = 'false';
    });

    // Intersection Observer: animeer als element in beeld komt
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          if (el.dataset.animated === 'false') {
            el.dataset.animated = 'true';
            const target = parseFloat(el.dataset.target);
            const suffix = el.dataset.suffix;
            animateCounter(el, target, 1200); // 1200ms
            observer.unobserve(el);
          }
        }
      });
    }, {
      threshold: 0.3
    });

    titles.forEach(el => {
      if (el.dataset.target) {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }
})();
